import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import {
  sortableContainer,
  sortableElement,
  sortableHandle
} from 'react-sortable-hoc';

import {
  Icon,
  Button,
  Text,
  ButtonWithDropdown
} from 'components/common/Elements/Elements';

import { moveIndex } from 'utils/common';

import classes from './BodyFilterDropdown.module.scss';

const DragHandle = sortableHandle(() => (
  <Icon size="16px" className={classes.iconHandle} icon="drugDrop" />
));

const SortableItem = sortableElement(
  ({ changeFilter, filter, handleChangeFilter, handleDellFilter }) => (
    <li
      className={cn(
        classes.option,
        changeFilter === filter.name && classes.option_change
      )}
    >
      <DragHandle />
      <div className={classes.item}>
        <Button
          className={classes.filter}
          onClick={() => handleChangeFilter(filter.name)}
        >
          <Text size={4}>{filter.name}</Text>
        </Button>
        {changeFilter !== filter.name && (
          <span className={classes.wrapDellFilterButton}>
            <Icon
              size="16px"
              icon="trash"
              className={classes.dellFilter}
              onClick={() => handleDellFilter(filter.name)}
            />
          </span>
        )}
      </div>
    </li>
  )
);

const SortableContainer = sortableContainer(({ children }) => {
  return <ul className={classes.listWrap}>{children}</ul>;
});

const BodyFilterDropdown = ({
  filterBackend,
  changeFilter,
  onDellFilter,
  onSaveFilter,
  handleChangeFilter
}) => {
  const handleDellFilter = name => {
    onDellFilter(name);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newArr = [...filterBackend.value];
    moveIndex(newArr, oldIndex, newIndex);
    onSaveFilter(changeFilter, newArr);
  };

  return (
    <ButtonWithDropdown
      className={classes.pointsWrap}
      buttonClass={classes.points}
      icon="3dots"
      tooltipText="All saved filters"
    >
      <SortableContainer onSortEnd={onSortEnd} useDragHandle>
        {filterBackend.value.map(
          (filter, index) =>
            index > 0 && (
              <SortableItem
                changeFilter={changeFilter}
                filter={filter}
                handleChangeFilter={handleChangeFilter}
                handleDellFilter={handleDellFilter}
                index={index}
                key={filter.name}
              />
            )
        )}
      </SortableContainer>
    </ButtonWithDropdown>
  );
};

BodyFilterDropdown.propTypes = {
  filterBackend: PropTypes.object.isRequired,
  changeFilter: PropTypes.string.isRequired,
  setChangeFilter: PropTypes.func.isRequired,
  setFilter: PropTypes.func.isRequired,
  onDellFilter: PropTypes.func.isRequired,
  onSaveFilter: PropTypes.func.isRequired,
  handleChangeFilter: PropTypes.func.isRequired
};

export default BodyFilterDropdown;
